import { CSSProperties, ComponentPropsWithoutRef, HTMLProps } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

const LINK_RESET_CLASSNAME = `m-0 w-full border-0 p-0 text-inherit decoration-inherit hover:text-inherit hover:decoration-inherit`;
const LINK_RESET_STYLE: CSSProperties = { fontWeight: 'inherit', display: 'inherit' };

const UnstyledLink = (props: LinkProps) => {
    const { className: _className, style: _style, ...rest } = props;
    const styleProps = useResetLinkCss(props);

    return <Link {...styleProps} {...rest} />;
};

const UnstyledAnchor = (props: ComponentPropsWithoutRef<'a'>) => {
    const { className: _className, style: _style, children, ...rest } = props;
    const styleProps = useResetLinkCss(props);

    return (
        <a {...styleProps} {...rest}>
            {children}
        </a>
    );
};

const useResetLinkCss = <T extends Pick<HTMLProps<any>, 'style' | 'className'>>(props: T) => {
    const { className, style = {} } = props;

    return {
        style: { ...LINK_RESET_STYLE, ...style },
        className: twMerge(LINK_RESET_CLASSNAME, className),
    };
};

export { UnstyledLink, UnstyledAnchor };
